/**
 * Shared React Query cache options for the `savedView.listSavedViews` query, used by
 * BOTH the login-time warmup fetch (`useWarmSavedViews`) and the per-page query
 * (`useTableViews`) so their cache behaviour can't drift.
 *
 * - `staleTime`: within this window the warm cache is reused with no refetch, so the
 *   first navigation to a list page fires no blocking views round-trip. Bounded (not
 *   `Infinity`) so a shared default another user changes is eventually picked up.
 * - `gcTime`: keep the warmup query around long enough to survive the login→navigate
 *   gap. Org switch clears the cache (`AuthStore.changeOrg` → `queryClient.clear()`),
 *   so a long `gcTime` can't leak another org's views.
 */
export const SAVED_VIEW_QUERY_OPTIONS = {
    staleTime: 5 * 60_000,
    gcTime: 60 * 60_000,
} as const;
